<script>
  import {
		Card,
    CardBody,
    CardFooter,
    CardHeader,
    CardSubtitle,
    CardText,
    CardTitle,
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
    } from 'sveltestrap';
  import { api_url, path } from "../ConfigService.js";

  export let id;
  export let key;
  export let data=false;
  export let open=false;
  export let selected=[];
  export let variant=[];
  export let checkboxes=[];
  export let selectedData=false;
  export let addToCartCount=0;
  const toggle = () => (selectedData = !selectedData);

  $: {
    if(selectedData) {
        open=true;
    } else {
        open=false;
        selected=[];
    		variant=[];
    }
  }

	async function addToCart() {
    let ids=[];
    let files=[];
    for(let i=0; i<checkboxes.length; i++) {
	if(checkboxes[i]) {
		ids[ids.length]=selectedData[i]['id'];
		files[files.length]=selectedData[i]['file'];
	}
    }
	const resp = await fetch($api_url+'?addToCartMultiple=true&album='+id+'&key='+key, {
		method: 'POST',
		body: JSON.stringify({
			ids: ids,
			files: files,
			variant: variant,
			selected: selected
		})
	})
    data = await resp.json();
    if(await data) {
      if(await data.cart) { addToCartCount=await data.cart.length; }
      else { addToCartCount=0; }
    }
    closeSelect();
	}

	function newVariant(index, value) {
		//uloží ID varianty pro přidání do košíku
		variant[index]=parseInt(value);
    if(typeof selected[index] === 'undefined') { selected[index]="0"; }
		return "";
	}
	function closeSelect() { checkboxes=[]; selectedData=false; open=false; }
  function getPrice(i, cena, min=1) {
 	return parseInt(cena)+",-Kč/ks"
  	/*if(i == "0") { return parseInt(cena)+",-Kč/ks"; }
  	return "celkem: "+(i+1)*parseInt(cena)+",-Kč";*/
  	//return ((i+1+pocetAdd(min))*parseInt(cena)); 
  }
  function setValue(z, value) { selected[z]=value; }
  function pocetCount(minimalni, maximalni) {
    return parseInt(maximalni)-pocetAdd(minimalni);
  }
  function pocetAdd(minimalni) {
    let min=parseInt(minimalni);
    if(min && min>1) { return (min-1); }
    return 0;
  }
  function setItem(d, z, count) {
    selected[z]=count;
    if(d.variant.length==1) { addToCart(); }
  }
</script>
{#await data}

{:then data}
  <Modal isOpen={open} {toggle} size="xl" scrollable>
    <ModalHeader {toggle} style="width:100%;">
    	<div class="confirmOnTop"><Button color="primary" outline on:click="{()=>addToCart()}">Potvrdit</Button></div>
    	Vyberte prosím variantu fotografie</ModalHeader>
    <ModalBody>
      <div class="variantBoxes">
        {#each data.variant as vr, z}
          {#if vr['fs_varianta.skupinova']!="1"}
            <div class="variant-box">
              <Card style="width:350px;max-width:100%;">
                <div class="variant-box-card">
                  <CardHeader>
                    <b>{vr['fs_varianta.nazev']}</b>
                  </CardHeader>
                  <CardBody>
                    <p>{@html vr['fs_varianta.popis']}</p>
                    { newVariant(z,vr['id_fs_varianta'])}
                    {#if parseInt(vr['fs_varianta.pocet'])==1}
                      <div class="txtcenter">
                        {#if selected[z]==1}
                          <Button color="danger" on:click="{()=>setItem(data, z,0)}">Odebrat</Button>
                        {:else}
                          <Button color="primary" on:click="{()=>setItem(data, z,1)}">
                            {#if vr.cena!=0}
                              Vybrat (cena {vr.cena},-Kč)
                            {:else}
                              Vybrat
                            {/if}
                          </Button>
                        {/if}
                      </div>
                    {:else}
                      <select bind:value={selected[z]}>
                        <option value="0">Vyberte počet...</option>
                        {#each Array(pocetCount(vr['fs_varianta.minimalni_pocet'], vr['fs_varianta.pocet'])) as _, i}
                          <option value="{(i+1+pocetAdd(vr['fs_varianta.minimalni_pocet']))}">
                            {(i+1+pocetAdd(vr['fs_varianta.minimalni_pocet']))}ks
                          </option>
                        {/each}
                      </select>
                      <div class="price">{getPrice(selected[z], vr.cena)}</div>
                      {#if vr['fs_varianta.file']}
                        <br /><br />
                        <center><img src="{$path}{data.config.folderVariant}/{vr['fs_varianta.file']}" alt="Ukázka balíčku" nosave style="max-height:190px;" /></center>
                      {/if}
                    {/if}
                  </CardBody>
                </div>
              </Card>
            </div>
            {#if parseInt(vr['fs_varianta.pocet'])==1}
                <br style="clear:both" />
            {/if}
          {/if}
        {/each}
      </div>
    </ModalBody>
    <ModalFooter>
      <Button color="primary" on:click="{()=>addToCart()}">Potvrdit</Button>
      <Button color="secondary" on:click={()=>closeSelect()}>Zrušit</Button>
    </ModalFooter>
 </Modal>
{/await}

<style>
  .price { float:right; margin-top:10px; }
  .txtcenter { text-align: center; }
  .variantBoxes { flex-wrap:wrap; row-gap:5px; float:left; }
  .variant-box { width:325px; float:left; margin:0 10px 7px; display:flex; flex: 1 1 auto; }
  .variant-box-card { flex: 1 1 auto; }
  .confirmOnTop { float:right; position: absolute; right: 50px; top: 30px; transform: translateY(-50%); }
  @media (max-width:960px) {
    .confirmOnTop { display:none; }
  }
</style>
